<template>
  <div class="container container-fluid flex">
    <div v-if="showComponentData">
      <div class="row">
        <div v-for="(customField, index) in customFields" :key="index">
          <div class="form-group bordered ">
            <div class="row">
              <div class="col-md-3 mt-3">
                <label :for="'persons' + index" class="form-label text-left">
                  {{ getFieldDescription('persons') }}
                </label>
              </div>
              <div class="col-md-3 mt-3">
                <label :for="'person_name' + index" class="form-label text-left">
                  Nombre y Apellido
                </label>
                <input
                  type="text"
                  class="form-control"
                  :name="'person_name' + index"
                  :id="'person_name' + index"
                  v-model="customField.person_name"
                  required="required"
                  maxlength="191"
                />
              </div>
              <div class="col-md-3 mt-3">
                <label :for="'person_phone' + index" class="form-label text-left">
                  Teléfono
                </label>
                <input
                  type="text"
                  class="form-control"
                  :name="'person_phone' + index"
                  :id="'person_phone' + index"
                  v-model="customField.person_phone"
                  required="required"
                  maxlength="10"
                />
              </div>
              <div class="col-md-3 mt-3">
                <label :for="'person_relation' + index" class="form-label text-left">
                  Relación
                </label>
                <input
                  type="text"
                  class="form-control"
                  :name="'person_relation' + index"
                  :id="'person_relation' + index"
                  v-model="customField.person_relation"
                  required="required"
                  maxlength="191"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="addCustomField" class="btn btn-secondary mt-2">Agregar Persona</div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';

export default {
  name: 'FormSinesterPersons',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const customFields = ref([]);

    const cargarDatos = () => {
      try {
        showComponentData.value = dataCompany.value && dataCompany.value.persons;
      } catch (error) {
        console.error(error);
      }
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);

      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;

        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFormDataChanged = () => {
      const formData = {
        person_name: customFields.value.map((field) => field.person_name),
        person_phone: customFields.value.map((field) => field.person_phone),
        person_relation: customFields.value.map((field) => field.person_relation),
      };
      emit('formDataChanged', formData);
    };

    const addCustomField = () => {
      customFields.value.push({ person_name: '', person_phone: '', person_relation: '' });
      emitFormDataChanged();
    };

    onMounted(cargarDatos);

    watch(customFields, () => {
      emitFormDataChanged();
    }, { deep: true });

    return {
      dataCompany,
      showComponentData,
      getFieldDescription,
      dataFormsField,
      addCustomField,
      customFields,
    };
  },
};
</script>
